import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
//@ts-ignore
import reportWebVitals from "./reportWebVitals";
import { ShaneClientProvider } from "./core/shaneClient/ShaneClientProvider";
import * as Sentry from "@sentry/react";
import { sentryDsn } from "./const";
import { createTamagui, TamaguiProvider } from "tamagui";
import config from "@shane-collective/design-system/dist/themes/tamagui.config";
import { BrowserRouter } from "react-router-dom";
// import liteClient from "algoliasearch/lite";
// import { InstantSearch } from "react-instantsearch";

Sentry.init({
  dsn: sentryDsn,
  environment:
    //@ts-ignore
    process.env.NODE_ENV === "production" ? "production" : "development",
  beforeSend(event) {
    // Only send errors if the environment is production (i.e. not running the code locally)
    if (event.environment !== "production") {
      return null;
    }
    return event;
  },
});

// const searchClient = liteClient(
//   //@ts-ignore
//   process.env.REACT_APP_ALGOLIA_ACCOUNT_ID,
//   //@ts-ignore
//   process.env.REACT_APP_ALGOLIA_APP_ID
// );

const tamaguiConfig = createTamagui(config);

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  rootElement.style.overflow = "hidden";
  rootElement.style.height = "100vh";

  root.render(
    <React.StrictMode>
      <ShaneClientProvider>
        <TamaguiProvider config={tamaguiConfig} defaultTheme="sun">
          <BrowserRouter>
            {/* @ts-ignore */}
            {/* <InstantSearch searchClient={searchClient} indexName="locations_index"> */}
              <App  />
            {/* </InstantSearch> */}
          </BrowserRouter>
        </TamaguiProvider>
      </ShaneClientProvider>
    </React.StrictMode>
  );
}

reportWebVitals();
